import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/img/ZBEdge-LO-lightBG.png'


const _hoisted_1 = { id: "SmartSessionEndPage" }
const _hoisted_2 = { id: "smartSessionEndInner" }
const _hoisted_3 = {
  id: "smartSessionEndTitle",
  "data-testid": "smartSessionEndTitle"
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { id: "logoWrap" }, [
        _createElementVNode("img", {
          id: "logo",
          src: _imports_0,
          alt: "ZBEdge"
        })
      ], -1)),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('smart_session_end_title')), 1),
      _createElementVNode("div", {
        id: "smartSessionEndText",
        "data-testid": "smartSessionEndText",
        innerHTML: _ctx.$t('smart_session_end_text')
      }, null, 8, _hoisted_4)
    ])
  ]))
}